import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import store from './store';
import {ThemeProvider} from 'styled-components';
import mainTheme from './themes/mainTheme';
import App from "./components/App";
import "slick-carousel/slick/slick.scss";
import 'bootstrap/scss/bootstrap.scss';
import './scss/style.scss';


store.subscribe(() => {
    const filter = store.getState().get('filter');
    const items = store.getState().getIn(['cart', 'items']);
    const delivery_info = store.getState().getIn(['cart', 'delivery_info']);
    console.log(filter);
    localStorage.setItem('LoguNoliktavaSavedState', JSON.stringify({
        filter,
        cart: {items, delivery_info}
    }))
});

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={mainTheme}>
            <App/>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root'));

window.addEventListener('build', function (e) {
    console.log(e);
});
